import { ShopSubscription } from 'shared/types/shop';

export const creditReviewInitialSubscription = (
  subscriptionsData: ShopSubscription[],
): ShopSubscription | undefined =>
  subscriptionsData?.find(
    subscription =>
      subscription.categories?.find(category => category === 'Credit Analysis') &&
      subscription.productLines?.find(productLine => productLine === 'Review'),
  );

export const creditReviewInitialSubscriptionId = (
  subscriptionsData: ShopSubscription[],
): number | undefined => creditReviewInitialSubscription(subscriptionsData)?.id;
